import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'num-data-protection',
  templateUrl: './data-protection.component.html',
  styleUrls: ['./data-protection.component.scss'],
})
export class DataProtectionComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
